


















import Vue from 'vue'

export default Vue.extend({
  name: 'DeleteDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onNoButtonClick (): void {
      this.$emit('close')
    },

    onYesButtonClick (): void {
      this.$emit('save')
    }
  },

  mounted (): void {
    setTimeout(() => {
      const yesBtn: any = this.$refs['yesBtn']
      if (yesBtn) {
        yesBtn.$el.focus()
      }
    }, 100)
  }
})
